var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('v-btn',{attrs:{"icon":"","small":""}},[_c('v-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltipHtml),expression:"tooltipHtml"}],attrs:{"small":""}},[_vm._v("mdi-note-outline")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }